<button (click)="previousDay()"
        class="left-date-browser"
        mat-icon-button
        aria-label="Previous day"
        title="Previous day">
  <mat-icon fontIcon="fa-chevron-left" fontSet="fas"></mat-icon>
</button>

<mat-form-field class="date-form-field">
  <input (dateChange)="selectDate($event.value);"
         [formControl]="date"
         [matDatepicker]="dp"
         matInput
         [placeholder]="'Select date'"
         aria-label="Select date" />
  <mat-datepicker-toggle [for]="dp" matSuffix></mat-datepicker-toggle>
  <mat-datepicker #dp disabled="false" touchUi="true"></mat-datepicker>
</mat-form-field>

<button (click)="nextDay()"
        class="right-date-browser"
        mat-icon-button
        aria-label="Next day"
        title="Next day">
  <mat-icon fontIcon="fa-chevron-right" fontSet="fas"></mat-icon>
</button>

<div class="right-spacer"></div>
